import { getTemporaryBlockId, getButtonActionId } from "../../../../../../../services/helpers/Helper";
import { TYPE_POPOVER } from "../constants";
import BlockPopover from "./block-popover";
import LinkPopover from "./link-popover";
import PhonePopover from "./phone-popover";
import TextPopover from "./text-popover";

const CardButtonEditor = (props) => {
   const { button, onChange, faqId, index, onClose, handleChangeButton } = props;
   let { data, buttons } = props;

   const onChangeTitleButton = (e) => {
      if (handleChangeButton) {
         const value = e.target.value;
         buttons[index].title = value;
         handleChangeButton(buttons);
      }
   }

   const getPopover = () => {
      const type = button?.action?.type;
      switch (type) {
         case TYPE_POPOVER.URL:
            return <LinkPopover {...props} />;
         case TYPE_POPOVER.PHONE_NUMBER:
            return <PhonePopover {...props} />;
         case TYPE_POPOVER.BLOCK:
            return <BlockPopover {...props} />;
         default:
            return <TextPopover {...props} />;
      }
   }

   const onDelete = () => {
      if (handleChangeButton) {
         buttons = buttons.filter((m, i) => i !== index)
         handleChangeButton(buttons);
      }
      if (onChange) {
         data.blocks = data.blocks.filter((f) => getTemporaryBlockId(f) !== getButtonActionId(button.action));
      }
      onClose();
   }

   return (
      <div className="card-button-editor" style={{ left: 10 }}>
         <div className="card-button-editor-wrapper">
            <div className="card-button-editor-title">
               <h4 className="mt0 mb0">Hiệu chỉnh nút</h4>
            </div>
            <div className="card-button-editor-content">
               <div className="width100 mb5" style={{ marginTop: -30 }}>
                  <div className="card-button-editor-content-input-emoji">
                     <label className="text-smaller">Tiêu đề:</label>
                     <div>
                        <div className="input-text input-text-none-scrollbar text-single font-size-14">
                           <input type="text" value={button.title} onChange={onChangeTitleButton} />
                        </div>
                     </div>
                  </div>
               </div>
               {getPopover()}
            </div>
            <div className="card-button-editor-footer">
               <div className="card-button-editor-footer-wrapper clearfix">
                  <a className="btn btn-default pull-left" onClick={onDelete}>
                     Xóa
                  </a>
                  <a className="btn btn-primary pull-right" onClick={onClose}>
                     Hoàn tất
                  </a>
               </div>
            </div>
         </div>
      </div>
   )
}

export default CardButtonEditor;